import './assets/reset.css'
import './assets/common.css'
import Vue from 'vue'
import {
  Select,
  Option,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Collapse,
  CollapseItem,
  Pagination,
  Button,
  Radio,
  Loading,
  TableColumn,
  TabPane,
  Table,
  Tabs,
  Divider,
  Upload,
  Tooltip,
  Message,
  Tag,
  Form,
  FormItem,
  Input,
  DatePicker
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import router from './router'
import ch from './common/lang/zh'
import en from './common/lang/en'
import ko from './common/lang/ko'
import ru from './common/lang/ru'
import ja from './common/lang/ja'
import VueI18n from 'vue-i18n'
import store from './store/index'
import Helper from './helpers/helper'
import RouterTools from './helpers/router'
import LineChart from './components/common/LineChart'
import { Plugin } from 'vue-fragment'
import './components/common/Toast/toast.css';
import Toast from './components/common/Toast/index';
Vue.use(Plugin)
Vue.use(Toast);

import Router from 'vue-router'

/**
 * Fixed compatibility issues with low version IE. lyx.
 */
import promise from 'es6-promise'
promise.polyfill();

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Helper);
Vue.use(RouterTools);

Vue.component(Pagination.name, Pagination);
Vue.prototype.$message = Message;
Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Collapse)
Vue.use(Tooltip)
Vue.use(CollapseItem)
Vue.use(Button)
Vue.use(TableColumn)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(Radio)
Vue.use(Loading)
Vue.use(Upload)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(DatePicker)
Vue.component('line-chart', LineChart);

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

const BigNumber = require("bignumber.js");
BigNumber.config({ EXPONENTIAL_AT: 20 })

/**
 * 全局组件注册
 */

import OntPagination from './components/common/OntPagination'
Vue.component('ont-pagination', OntPagination);

Vue.config.productionTip = process.env.NODE_ENV !== 'production';

const yuyan = navigator.language.split('-')[0]
let yuyans
switch (yuyan) {
  case 'zh':
    yuyans = 'ch'
    break
  case 'en':
    yuyans = 'en'
    break
  default:
    yuyans = 'en'
}
Vue.use(VueI18n)
let localLang
switch (localStorage.getItem('user_lang')) {
  case 'zh':
    localLang = 'ch'
    break
  case 'ch':
    localLang = 'ch'
    break
  case 'en':
    localLang = 'en'
    break
  default:
    localLang = 'en'
}
const i18n = new VueI18n({
  locale: localLang || yuyans,
  messages: {
    ch: ch,
    zh: ch,
    en: en
  }
})

locale.i18n((key, value) => i18n.t(key, value))

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js